export var BreakpointDefs = {
    'phone': 320,
    'phone-md': 360,
    'phone-lg': 412,
    'phone-xl': 480,
    'tablet': 640,
    'tablet-md': 768,
    'tablet-lg': 920,
    'tablet-xl': 1024,
    'desktop': 1152,
    'desktop-md': 1280,
    'desktop-ml': 1366,
    'desktop-lg': 1440,
    'desktop-xl': 1680,
};
export var BreakpointNames = Object.keys(BreakpointDefs);
export function isBreakpointName(string) {
    return BreakpointNames.includes(string);
}
export function breakpoint(key) {
    return BreakpointDefs[key];
}
